import React from "react";

const VerifyOtp = () => {
  return <section>Verify Otp</section>;
};

export default VerifyOtp;
